export const CLOSEST = 1;
export const OCTAVE = 2;
